import React from 'react';
const blocks = [{
  name: 'Warm-up',
  min: 10,
  color: 'bg-white/25',
  text: 'text-white'
}, {
  name: 'Floor',
  min: 9,
  color: 'bg-coral',
  text: 'text-white'
}, {
  name: 'Bars',
  min: 9,
  color: 'bg-indigo',
  text: 'text-white'
}, {
  name: 'Beam',
  min: 9,
  color: 'bg-teal',
  text: 'text-white'
}, {
  name: 'Vault',
  min: 9,
  color: 'bg-amber',
  text: 'text-ink'
}, {
  name: 'Game',
  min: 8,
  color: 'bg-white/40',
  text: 'text-ink'
}, {
  name: 'Cool-down',
  min: 6,
  color: 'bg-white/15',
  text: 'text-white'
}];
const coverage = [{
  label: 'Rotation Map',
  body: 'The whole class on one page: objective, setup, group split, warm-up, four timed stations, a game and a cool-down'
}, {
  label: 'Progression Ladder',
  body: 'The week’s skill from the easy version to the goal — easier, on-target, harder — with the rule to move a kid up or down'
}, {
  label: '30 · 45 · 60 minutes',
  body: 'Same four phases, the minutes already worked out for your slot'
}, {
  label: 'Solo or with helpers',
  body: 'The 4-Station Flow keeps rotations running while you coach the station that needs you'
}, {
  label: 'Mixed-Level Tweak',
  body: 'On every skill: what to change on the spot for the youngest and the strongest'
}, {
  label: 'Spotting & Safety Note',
  body: 'On every skill page: where to stand and what to protect, within recreational scope'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full bg-ink text-white" data-id="element-236" data-mp="s2cxp7dmazw6">
      <div className="apparatus-strip h-1.5 w-full" aria-hidden="true" data-id="element-237" data-mp="w3or7nzm459n" />
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-238" data-mp="w3yh7bknqcfc">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-amber" data-id="element-239" data-mp="112011ypwqfrv">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-240" data-mp="162nqwh2egqki">
          The Class-Ready System
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/80 sm:text-lg" data-id="element-241" data-mp="2hgrhredoxylc">
          Lesson plans aren&apos;t new. Plans you can actually walk in and teach
          are. A template leaves you to fill in the class; a list of skills leaves
          you to build it. Here every week of the year comes solved in two pages:
          a <span className="font-semibold text-white" data-id="element-242" data-mp="21q0l0n4y7j31">Rotation Map</span> that runs the
          whole hour station by station, and a{' '}
          <span className="font-semibold text-white" data-id="element-243" data-mp="1wpw0mm0x647j">Progression Ladder</span> that takes the
          week&apos;s skill from the easy version to the goal. Open the week, print
          two pages, teach.
        </p>

        <div className="mx-auto mt-9 max-w-3xl text-left" data-id="element-244" data-mp="1is7fdd2xwv1y">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-245" data-mp="1itqxl985pg6d">A 60-minute class</p>
          <div className="mt-2 flex h-11 w-full overflow-hidden rounded-xl border border-ink-line" data-id="element-246" data-mp="1e068y7sgdyju">
            {blocks.map(b => <div key={b.name} style={{
            flexGrow: b.min,
            flexBasis: 0
          }} className={`${b.color} ${b.text} flex items-center justify-center font-display text-sm font-extrabold sm:text-base`} data-id="element-247" data-mp="ld1xbjyuulz3">
                {b.min}′
              </div>)}
          </div>
          <ol className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-[12.5px] text-white/75 sm:grid-cols-4 lg:grid-cols-7" data-id="element-248" data-mp="2n30smslqjf8i">
            {blocks.map((b, i) => <li key={b.name} className="flex items-center gap-1.5" data-id="element-249" data-mp="3fqn4sp913s6z" data-mpi={i}>
                <span className={`h-2.5 w-2.5 flex-none rounded-sm ${b.color}`} data-id="element-250" data-mp="3frg7nf4v9xju" />
                {i + 1}. {b.name}
              </li>)}
          </ol>
        </div>

        <ul className="mt-10 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-251" data-mp="36p6vylxv3y4v">
          {coverage.map(item => <li key={item.label} className="rounded-xl border border-ink-line bg-white/5 px-4 py-3" data-id="element-252" data-mp="3atn0airtuxhz">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-amber" data-id="element-253" data-mp="1vcwaz1pd16az">{item.label}</span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-254" data-mp="2fjjfn5zpn3r9">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}